module.exports = __webpack_public_path__ + "static/media/xfinity-verticle-short-spa.0ba86e51.png";